import * as _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";

/* Load Redux Store */
import { ActionCreator } from "../../../../../../../actions/actions";
import { ConfigurationsActionCreators } from "../../../../../actions/actionCreators";
import { configurationsStoreSelectors } from "../../../../../store/store";

import { levelTextById } from "../../../../Utils/get-sound-level";

import "./SoundsInformation.component.scss";

export interface SoundsInformationProps {
    soundPercentage: any;
    soundDecibels: any;
    getSoundDecibels: ActionCreator;
    getSoundPercentages: ActionCreator;
    open: boolean;
}

class SoundsInformation extends Component<SoundsInformationProps, {}> {
    componentDidMount() {
        if(this.props.soundPercentage.length === 0){
            this.props.getSoundPercentages();
        }
        if(this.props.soundDecibels.length === 0) {
            this.props.getSoundDecibels();
        }

    }

    render() {
        return (
            <div
                id="soundsInformation"
                className={this.props.open ? `open` : ""}
            >
                <div>
                    <div className="row info-sounds-tables">
                        <div className="col-6">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Decibels</th>
                                        <th>Volume Level</th>
                                        <th>Sub-Level 1</th>
                                        <th>Sub-Level 2</th>
                                        <th>Sub-Level 3</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.props.soundDecibels &&
                                        this.props.soundDecibels.map(
                                            decibel => {
                                                return (
                                                    <tr key={decibel.sound_volume_level_id}>
                                                        <td>
                                                            {levelTextById(
                                                                decibel.sound_volume_level_id
                                                            )}
                                                        </td>
                                                        <td>{decibel.sound_volume_level_id}</td>
                                                        <td>
                                                            {
                                                                decibel.sub_level_1
                                                            }
                                                        </td>
                                                        <td>
                                                            {
                                                                decibel.sub_level_2
                                                            }
                                                        </td>
                                                        <td>
                                                            {
                                                                decibel.sub_level_3
                                                            }
                                                        </td>
                                                    </tr>
                                                );
                                            }
                                        )}
                                </tbody>
                            </table>
                        </div>
                        <div className="col-6">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Percentage</th>
                                        <th>Volume Level</th>
                                        <th>Sub-Level 1</th>
                                        <th>Sub-Level 2</th>
                                        <th>Sub-Level 3</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.props.soundPercentage &&
                                        this.props.soundPercentage.map(
                                            percentage => {
                                                return (
                                                    <tr key={percentage.sound_volume_level_id}>
                                                        <td>
                                                            {levelTextById(
                                                                percentage.sound_volume_level_id
                                                            )}
                                                        </td>
                                                        <td>
                                                            {percentage.sound_volume_level_id}
                                                        </td>
                                                        <td>
                                                            {
                                                                percentage.sub_level_1
                                                            }
                                                            %
                                                        </td>
                                                        <td>
                                                            {
                                                                percentage.sub_level_2
                                                            }
                                                            %
                                                        </td>
                                                        <td>
                                                            {
                                                                percentage.sub_level_3
                                                            }
                                                            %
                                                        </td>
                                                    </tr>
                                                );
                                            }
                                        )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    soundDecibels: configurationsStoreSelectors.soundDecibels(state),
    soundPercentage: configurationsStoreSelectors.soundPercentage(state)
});

const mapDispatchToProps = {
    getSoundDecibels: ConfigurationsActionCreators.getSoundDecibels,
    getSoundPercentages: ConfigurationsActionCreators.getSoundPercentages
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SoundsInformation);
